import { render, staticRenderFns } from "./My-Form.vue?vue&type=template&id=590d6db8&scoped=true"
import script from "./My-Form.vue?vue&type=script&lang=js"
export * from "./My-Form.vue?vue&type=script&lang=js"
import style0 from "./My-Form.vue?vue&type=style&index=0&id=590d6db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d6db8",
  null
  
)

export default component.exports